import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconReset = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M9.06445 7.5H5.84008C7.34081 5.62762 9.60155 4.5 12.0645 4.5C16.4756 4.5 20.0645 8.08887 20.0645 12.5H22.0645C22.0645 6.98633 17.5781 2.5 12.0645 2.5C9.38879 2.5 6.90405 3.56708 5.06445 5.37927V3.5H3.06445V9.5H9.06445V7.5Z" }),
            React.createElement("path", { d: "M15 17.5H18.2244C16.7236 19.3724 14.4629 20.5 12 20.5C7.58887 20.5 4 16.9111 4 12.5H2C2 18.0137 6.48633 22.5 12 22.5C14.6757 22.5 17.1604 21.4329 19 19.6207V21.5H21V15.5H15V17.5Z" }))));
};
